import EngineModule from '../EngineModule';
import {NS as PlannerFurnitureEditorNS} from '../components/viewer/planner/furniture/Editor/PlannerFurnitureEditor';

export default () => EngineModule.all.find(x => x.id === 'viewer-planner-furniture-editor') || new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth : false,
	id: 'viewer-planner-furniture-editor',
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	allowedCustomers: null,
	modulesBefore: ['product-editor'],
	modulesAfter: [],
	usableCondition: {
		type: 'and',
		LHS: {
			type: 'notequal',
			component: 'K.basket',
			property: 'TARGET.basket.currentProduct',
			value: null
		},
		RHS: {
			type: 'or',
			LHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
				value: true
			},
			RHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
				value: null
			}
		}
	},
	displayCondition: null,
	generateComponentConfiguration(): PlannerFurnitureEditorNS.Configuration {
		return {
			searchBar : this.configuration.searchBar ? true : false,
			countFurniture : this.configuration.countFurniture ? true : false,
			typeFilter : this.configuration.typeFilter ? this.configuration.typeFilter : null
		};
	}
});
